import { memo, useState } from 'react';
import { Button, Alert } from 'react-bootstrap';
import { useApp } from '../../../../hook/app.hook';
import { Question, Section } from '../../../../response/test.response';
import SectionPickerComponent from '../section-picker.component';

const JeeActionMComponent = () => {
  const {
    testRes,
    moveNext,
    movePrevious,
    markQuestionForRevisit,
    markQuestionAsSaved,
    clearQuestionResponse,
    updateActiveSection,
    updateActiveQuestion,
  } = useApp();

  const [showAlert, setShowAlert] = useState(false);

  const section = testRes.sectionList.filter(
    (section: Section) => section.active,
  )[0];

  const question = section.questionList.filter(
    (question: Question) => question.active,
  )[0];

  const activeQuestionIndex = question.index;
  const currentSectionIndex = testRes.sectionList.findIndex(
    (section: Section) => section.active,
  );

  const handleSaveAndNext = () => {
    if (!question.attempted) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }
    markQuestionAsSaved(question.id);
    if (question.markedForRevisit) {
      markQuestionForRevisit(question.id);
    }
    moveNextQuestion();
  };

  const moveNextQuestion = () => {
    if (activeQuestionIndex < section.questionList.length) {
      moveNext();
    } else {
      if (currentSectionIndex < testRes.sectionList.length - 1) {
        const nextSection = testRes.sectionList[currentSectionIndex + 1];
        updateActiveSection(nextSection.id);
        updateActiveQuestion(nextSection.questionList[0].id);
      } else {
        const firstSection = testRes.sectionList[0];
        updateActiveSection(firstSection.id);
        updateActiveQuestion(firstSection.questionList[0].id);
      }
    }
  };

  const handleNext = () => {
    if (!question.saved) {
      clearQuestionResponse(question.id);
    }
    moveNextQuestion();
  };

  const handleClear = () => {
    clearQuestionResponse(question.id);
  };

  const handleSaveAndMarkForReview = () => {
    if (!question.attempted) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }
    if (!question.markedForRevisit) {
      markQuestionForRevisit(question.id);
    }
    markQuestionAsSaved(question.id);
    moveNextQuestion();
  };

  const handleMarkForReviewAndNext = () => {
    if (!question.markedForRevisit) {
      markQuestionForRevisit(question.id);
    }
    if (!question.saved) {
      clearQuestionResponse(question.id);
    }
    moveNextQuestion();
  };

  const handleBack = () => {
    if (activeQuestionIndex > 1) {
      movePrevious();
    } else {
      if (currentSectionIndex > 0) {
        const previousSection = testRes.sectionList[currentSectionIndex - 1];
        updateActiveSection(previousSection.id);
        updateActiveQuestion(
          previousSection.questionList[previousSection.questionList.length - 1]
            .id,
        );
      } else {
        const lastSection = testRes.sectionList[testRes.sectionList.length - 1];
        updateActiveSection(lastSection.id);
        updateActiveQuestion(
          lastSection.questionList[lastSection.questionList.length - 1].id,
        );
      }
    }
  };

  return (
    <>
      {/* Mobile Alert */}
      {showAlert && (
        <Alert
          variant="warning"
          dismissible
          onClose={() => setShowAlert(false)}
          className="position-fixed ft-12 py-2 px-3 m-2"
          style={{
            top: '8px',
            left: '8px',
            right: '8px',
            zIndex: 1050,
          }}
        >
          Please attempt the question first
        </Alert>
      )}

      <div className="py-2">
        <div className="border-top border-lightgray pt-2">
          {/* Primary Actions - 2x2 Grid */}
          <div
            className="d-grid gap-2 mb-2"
            style={{ gridTemplateColumns: '1fr 1fr' }}
          >
            <Button
              variant="success"
              size="sm"
              className="font-weight-600 py-2 text-white border-0 rounded-2 ft-11"
              onClick={handleSaveAndNext}
            >
              SAVE & NEXT
            </Button>

            <Button
              variant="light"
              size="sm"
              className="font-weight-600 py-2 text-dark border border-secondary rounded-2 ft-11"
              onClick={handleClear}
              disabled={!question.attempted}
            >
              CLEAR
            </Button>

            <Button
              variant="warning"
              size="sm"
              className="font-weight-600 py-2 text-white border-0 rounded-2 ft-11"
              onClick={handleSaveAndMarkForReview}
            >
              SAVE & REVIEW
            </Button>

            <Button
              variant="primary"
              size="sm"
              className="font-weight-600 py-2 text-white border-0 rounded-2 ft-11"
              onClick={handleMarkForReviewAndNext}
            >
              REVIEW & NEXT
            </Button>
          </div>

          {/* Navigation - Back/Next */}
          <div className="d-flex align-items-center justify-content-between gap-2 pt-2 border-top border-lightgray">
            <Button
              size="sm"
              variant="outline-secondary"
              className="flex-grow-1 py-2 rounded-2 font-weight-600 ft-12"
              onClick={handleBack}
            >
              <img
                src="/images/left-arrow.svg"
                className="me-1"
                alt=""
                style={{ width: '12px', height: '12px' }}
              />
            </Button>

            <SectionPickerComponent />
            <Button
              size="sm"
              variant="outline-secondary"
              className="flex-grow-1 py-2 rounded-2 font-weight-600 ft-12"
              onClick={handleNext}
            >
              <img
                src="/images/end-arrow.svg"
                className="ms-1"
                alt=""
                style={{ width: '12px', height: '12px' }}
              />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(JeeActionMComponent);
